import React from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import { Input } from "antd";

//PROJECT IMPORTS
import AddLoanCharge from "./AddLoanCharge";
import AssignLoanOfficer from "./AssignLoanOfficer";
import Close from "./Close";
import CloseAsRescheduled from "./CloseAsRescheduled";
import CreateGuarantor from "./CreateGuarantor";
import Foreclosure from "./Foreclosure";
import LoanPrepayment from "./LoanPrepayment";
import LoanRepayment from "./LoanRepayment";
import RecoverFromGuarantor from "./RecoverFromGuarantor";
import Reschedule from "./Reschedule";
import UndoDisbursal from "./UndoDisbursal";
import UndoApproval from "./UndoApproval";
import ViewGuarantors from "./ViewGuarantors";
import WaiveInterest from "./WaiveInterest";
import WriteOff from "./WriteOff";
import LoanScreenReports from "./LoanScreenReports";
import ApproveLoanAcc from "./ApproveLoanAccount";
import RejectLoanAcc from "./RejectLoanAcc";
import Disbursal from "./Disbursal";
import DisburseToSavings from "./DisburseToSavings";
import AddCollateral from "./AddCollateral";
import ModifyApplication from "./ModifyApplication";
import WithdrawnByClient from "./WithdrawnByClient";
import UnassignLoanOfficer from "./UnassignLoanOfficer";
import DeleteLoanAccount from "./Delete";
import ChangeLoanOfficer from "./ChangeLoanOfficer";

const { TextArea } = Input;
const GLIMLoanMainActionPage = (props) => {
    const { userData } = props;
    const { state } = useLocation();

    const renderActions = () => {
        switch (state?.actionLabel?.toLowerCase()) {
            case "add loan charge":
                return <AddLoanCharge userData={userData} />;
            case "approve loan account":
                return <ApproveLoanAcc userData={userData} />;
            case "reject loan account":
                return <RejectLoanAcc userData={userData} />;
            case "modify application":
                return <ModifyApplication userData={userData} />;
            case "assign loan officer":
                return <AssignLoanOfficer userData={userData} pageTitleParam={state?.actionLabel} />;
            case "change loan officer":
                return <ChangeLoanOfficer userData={userData} />;
            case "disburse":
                return <Disbursal userData={userData} />;
            case "disburse to savings":
                return <DisburseToSavings userData={userData} />;
            case "add collateral":
                return <AddCollateral userData={userData} />;
            case "close":
                return <Close userData={userData} />;
            case "close as rescheduled":
                return <CloseAsRescheduled userData={userData} />;
            case "create guarantor":
                return <CreateGuarantor userData={userData} />;
            case "foreclosure":
                return <Foreclosure userData={userData} />;
            case "loan prepayment":
                return <LoanPrepayment userData={userData} />;
            case "loan screen reports":
                return <LoanScreenReports userData={userData} />;
            case "make repayment":
                return <LoanRepayment userData={userData} />;
            case "recover from guarantor":
                return <RecoverFromGuarantor userData={userData} />;
            case "reschedule":
                return <Reschedule userData={userData} />;
            case "undo disbursal":
                return <UndoDisbursal userData={userData} />;
            case "undo approval":
                return <UndoApproval userData={userData} />;
            case "view guarantors":
                return <ViewGuarantors userData={userData} />;
            case "waive interest":
                return <WaiveInterest userData={userData} />;
            case "write off":
                return <WriteOff userData={userData} />;
            case "withdrawn by client":
                return <WithdrawnByClient userData={userData} />;
            case "unassign loan officer":
                return <UnassignLoanOfficer userData={userData} />;
            case "delete":
                return <DeleteLoanAccount userData={userData} />;
            case "view guarantors":
                return <ViewGuarantors userData={userData} />;

            default:
                return <>No {state.actionLabel} Component found contact dev</>;
        }
    };
    return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(GLIMLoanMainActionPage);
